import { gql } from '@apollo/client';

export default gql`
  mutation removePreferencesDistrict($input: DistrictRefInput!) {
    removeBuyerPreferencesDistrict(input: $input)
  }
`;
